import * as TestPanel from '../app/testPanel'
import { Chapter } from '@/types'
import { globalState } from '@codeleap/store'
import { useSharedSettings } from '../services/sharedSettings'
import { LocalStorage } from '@/utils'

const server = TestPanel.getEnv().server

export const state = globalState({}, { persistKey: `learn_onboarding_lesson_${server}` })

export function isCompleted(lesson: Chapter['id']): boolean {
  if (!lesson) return false
  return Boolean(state.get()?.[lesson])
}

export function setCompleted(lesson: Chapter['id'], to = true) {
  if (!lesson) return
  state.set({ [lesson]: to })
}

export function reset() {
  state.reset({})
  LocalStorage.removeItem(`learn_onboarding_lesson_${server}`)
}

export function use() {
  const { settings, isLoaded } = useSharedSettings()
  const lessonID = settings?.initial_lesson

  return {
    lessonID,
    loading: !isLoaded,
    isCompleted: () => isLoaded && isCompleted(lessonID),
    setCompleted: (to = true) => setCompleted(lessonID, to),
  }
}
